import * as React from "react";
import {
    Button,
    Grid,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel
} from "@material-ui/core";
import { API } from "aws-amplify";
import { LoadingSpinner } from "../../../utils/LoadingSpinner";
import {useEffect, useState} from "react";
import { useCommonStyles } from './styles'

enum HubsProgram {
    ASSEMBIA = "ASSEMBIA",
    ASSISTRX = "ASSISTRX",
    EVERSANA = "EVERSANA"
}

const CancelHubsOrderSection: React.FC = () => {
    const classes = useCommonStyles();
    const [program, setProgram] = useState<HubsProgram | ''>('');
    const [cancelOrderRequest, setCancelOrderRequest] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [resultSuccessful, setResultSuccessful] = useState(false);
    const [partnerOrderId, setPartnerOrderId] = useState('');

    useEffect(() => {
        setCancelOrderRequest(getSampleJSON());
    }, []);

    const getSampleJSON = (): string => {
        return JSON.stringify({
            "partnerOrderId": "",
            "cancellationReason": ""
        }, null, 2);
    };

    const handleValidation = (): boolean => {
        if (!program) {
            alert("Please select a program");
            return false;
        }
        if (!cancelOrderRequest) {
            alert("Please enter a valid cancel order request JSON");
            return false;
        }
        try {
            JSON.parse(cancelOrderRequest);
        } catch (e) {
            alert("Invalid JSON format");
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (handleValidation()) {
            setFormSubmitted(true);

            const apiName = "ApaqPortalAPI";
            const path = "/hubs/order/cancel";

            const requestBody = {
                program,
                cancelOrderRequest
            };

            console.log("Selected Program:", program);
            console.log("Full Request Body:", requestBody);

            try {
                const response = await API.post(apiName, path, { body: requestBody });
                console.log("Success response:", response);
                setResultSuccessful(true);
                setPartnerOrderId(response.partnerOrderId);
            } catch (error) {
                console.error("Error details:", error);
                alert(`Error canceling order: ${error.response?.data?.message || error.message || "Unknown error"}`);
            } finally {
                setFormSubmitted(false);
            }
        }
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <h1>Cancel HUBS Order</h1>
                </Grid>

                <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                        <InputLabel>Program *</InputLabel>
                        <Select
                            value={program}
                            onChange={(e) => setProgram(e.target.value as HubsProgram)}
                            required
                        >
                            {Object.values(HubsProgram).map((prog) => (
                                <MenuItem key={prog} value={prog}>
                                    {prog}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label="Cancel Order Request (JSON) *"
                        multiline
                        rows={10}
                        value={cancelOrderRequest}
                        onChange={(e) => setCancelOrderRequest(e.target.value)}
                        variant="outlined"
                        className={classes.textField}
                        required
                        placeholder='Enter JSON for cancelOrderRequest'
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={handleSubmit}
                    >
                        Cancel Order
                    </Button>
                </Grid>

                {formSubmitted && (
                    <Grid item xs={12}>
                        <LoadingSpinner />
                    </Grid>
                )}

                {resultSuccessful && partnerOrderId && (
                    <Grid item xs={12}>
                        <div className={classes.successMessage}>
                            Partner Order ID: {partnerOrderId}
                        </div>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default CancelHubsOrderSection;
